import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Bar } from "react-chartjs-2";

/*
const data = {
    labels: ['Janv', 'Fev', 'Mars', 'Avr', 'Mai', 'Juin', 'Juillet', 'Aout', 'Sept', 'Oct', 'Nov', 'Dec'],
    datasets: [
        {
            label: 'Doc NRU',
            data: [12, 19, 3, 5, 2, 3, 7, 0, 0, 3, 11, 12],
            backgroundColor: 'rgb(234,137,0)',
        },
        {
            label: 'Doc DPU',
            data: [2, 19, 3, 5, 2, 3, 0, 5, 2, 3, 1, 1],
            backgroundColor: 'rgb(77,129,160)',
        },
        {
            label: 'Doc ERP',
            data: [3, 10, 13, 15, 22, 30, 0, 0, 0, 0, 0 ,0],
            backgroundColor: 'rgb(148,201,217)',
        },
    ],
}

 */

const Activity = (props) => {
    const monthsLabels = [
        "Janv",
        "Fev",
        "Mars",
        "Avr",
        "Mai",
        "Juin",
        "Juillet",
        "Aout",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
    ];
    const [docData, setDocData] = useState([]);
    const [dataSet, setDataSet] = useState({
        labels: monthsLabels,
        datasets: [],
    });
    const colors = [
        "#58D2C3",
        "rgb(77,129,160)",
        "rgb(148,201,217)",
        "rgb(99,172,136)",
        "rgb(122,91,143)",
        "rgb(131,23,195)",
        "rgb(195,23,118)",
        "rgb(215,9,90)",
        "rgb(234,137,0)",
        "rgb(77,129,160)",
        "rgb(148,201,217)",
    ];

    let baseThemeColor =
        props.uiTheme && props.uiTheme === "dark" ? "#dedada" : "#afabab";

    const options = {
        scales: {
            yAxes: [
                {
                    stacked: true,
                    gridLines: { color: baseThemeColor },
                    scaleLabel: {
                        fontColor: baseThemeColor,
                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: baseThemeColor,
                    },
                },
            ],
            xAxes: [
                {
                    stacked: true,
                    gridLines: { color: baseThemeColor },
                    scaleLabel: {
                        fontColor: baseThemeColor,
                    },
                    ticks: {
                        fontColor: baseThemeColor,
                    },
                },
            ],
        },
        maintainAspectRatio: false,
    };

    const now = moment().format("YYYY");

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {}, [props.uiTheme]);

    useEffect(() => {
        if (docData) {
            docData.map((item) => {
                item.data = JSON.parse(item.data);
                item.nb_month = JSON.parse(item.nb_month);
            });
            consolideData();
        }
    }, [docData]);

    const consolideData = () => {
        let buildSet = [];
        docData.map((item, index) => {
            buildSet.push({
                label: item.doctype,
                data: [],
                backgroundColor: colors[index],
            });
            monthsLabels.map((item2, index2) => {
                let resultIndex = _.indexOf(item.nb_month, index2 + 1);
                buildSet[index].data.push(
                    resultIndex >= 0 ? item.data[resultIndex] : 0
                );
            });
        });
        setDataSet((original) => {
            return {
                ...original,
                datasets: buildSet,
            };
        });
    };

    const fetchData = async () => {
        let result = await axios.get("/Api/Form_ref/stats/month");
        result.data ? setDocData(result.data) : null;
    };

    return (
        <div className={"card h-100 ueThemeBackground ueColorBase"}>
            
            <div className={"card-body mb-3"} style={{ height: "30vh" }}>
                
                <h5 className={"card-title"}>
                    <i className="fas fa-chart-line eu-btn-icon text-primary"></i>
                    
                    Activité - Année {now}
                </h5>

                <Bar data={dataSet} options={options} height={90} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        role: state.MeReducer.role,
        uiTheme: state.AppReducer.uiTheme,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {};
};

//export default connect(mapStateToProps, mapDispatchTProps)(Activity);
export default Activity;
